import { IHomepage } from "../interfaces/home.interface";
import { IRequest } from "../interfaces/authentication.interface";
import { strapiRequest } from "./requests.service";

export const getHomepage = async (): Promise<IRequest<IHomepage>> => {
    try {
        const query = `
            query HomepageHr {
                homepageHr {
                    modules
                    intro_video
                    intro_video_thumbnail {
                        url
                        alt: alternativeText
                    }
                }
            }`;


        const response = await strapiRequest.post<{
            data: {
                homepageHr: {
                    modules: string[],
                    intro_video?: string,
                    intro_video_thumbnail?: {
                        url: string,
                        alt: string
                    }
                }
            }
        }>(`/graphql`, {
            operationName: "HomepageHr",
            query
        });

        const modules = response.data?.data.homepageHr.modules ?? [];
        const introVideo = response.data?.data.homepageHr.intro_video;
        const videoThumbnail = response.data?.data.homepageHr.intro_video_thumbnail;

        return { success: true, data: { modules, introVideo, videoThumbnail } };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};